'use client';

import type { ReactNode } from 'react';

import { IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5';

import type { BaseComponentProps } from '../../base-component.types';
import { IconButton } from '../../icon-button';
import { ResourceBar } from '../../resource';

type PagerBarProps = BaseComponentProps & {
  onPrevious?: () => void;
  onNext?: () => void;
  children?: ReactNode;
};

/** The bar a resource stepped through one question at a time is tailed with. */
function PagerBar({
  style,
  className,
  children,
  onPrevious,
  onNext,
  testId,
}: PagerBarProps) {
  return (
    <ResourceBar
      style={style}
      className={className}
      edge="bottom"
      testId={testId}
      start={
        onPrevious && (
          <IconButton
            icon={<IoChevronBackOutline />}
            aria-label="Pregunta anterior"
            onClick={onPrevious}
          />
        )
      }
      center={children}
      end={
        onNext && (
          <IconButton
            icon={<IoChevronForwardOutline />}
            aria-label="Pregunta siguiente"
            onClick={onNext}
          />
        )
      }
    />
  );
}

export { PagerBar };
